var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              _vm._l(_vm.ticket.devices, function (device, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "selectgroup-pills" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "selectgroup-item",
                        staticStyle: { display: "block" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ticket.device,
                              expression: "ticket.device",
                            },
                          ],
                          staticClass: "selectgroup-input",
                          attrs: { type: "radio", name: "value", checked: "" },
                          domProps: {
                            value: device,
                            checked: _vm._q(_vm.ticket.device, device),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.ticket, "device", device)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "selectgroup-button text-start" },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(device.identificativoDevice)),
                            ]),
                            _c("br"),
                            _vm._v(
                              "\n             modello " +
                                _vm._s(device.brand.brand) +
                                " " +
                                _vm._s(device.modello.modello) +
                                " \n             "
                            ),
                            device.memoria
                              ? _c("span", [
                                  _vm._v(
                                    "\nmemoria " +
                                      _vm._s(device.memoria.memoria) +
                                      "\n\n             "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }